import { ParsedCampaignCookie } from './types';

export const setMetaCookie = (cookie: ParsedCampaignCookie): void => {
    const { serialized, domain, expires } = cookie;
    const expiresString = new Date(expires).toUTCString();
    document.cookie = `_fcb=${serialized};domain=${domain};expires=${expiresString};path=/`;
};

export const getSubdomainIndex = (domain: string): number => domain.split('.').length - 1;
